let hamburger = document.getElementById("hamburger");
let mainNav = document.getElementById("main-nav");
let navList = mainNav.querySelector("ul");

if (hamburger) {
  hamburger.addEventListener("click", (e) => {
    // console.log(e.target);
    console.log(hamburger);
    hamburger.classList.toggle("is-active");
    if (mainNav) {
      let isOpen = hamburger.classList.contains("is-active");
      console.log(navList);
      if (isOpen) {
        navList.classList.remove("pl-10");
        navList.classList.add("pl-4");
      } else {
        navList.classList.add("pl-10");
        navList.classList.remove("pl-4");
      }
      mainNav.className = isOpen
        ? "absolute ease-in-out z-40 transition-[padding,margin,opacity,max-width] opacity-100 duration-500 md:static overflow-hidden right-0 top-0 bottom-0 w-screen min-h-svh h-max max-w-80 md:max-w-none md:h-min md:min-h-fit md:w-min bg-emerald-50/95 md:bg-transparent"
        : "absolute ease-in-out z-40 transition-[padding,margin,opacity,max-width] opacity-20 md:opacity-100 duration-500 md:static right-0 top-0 bottom-0 w-screen min-h-svh h-max max-w-0 overflow-hidden md:max-w-none md:h-min md:min-h-fit md:w-min bg-emerald-50/95 md:bg-transparent";
    }
  });
}

